var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7996 7.99967H4.19973C3.56974 7.99967 3.1499 7.59983 3.1499 6.99983C3.1499 6.39984 3.56974 6 4.19973 6H16.7996C17.4296 6 17.8495 6.39984 17.8495 6.99983C17.8495 7.59983 17.4296 7.99967 16.7996 7.99967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6498 13.9997H7.34988C6.71988 13.9997 6.30005 13.5998 6.30005 12.9998C6.30005 12.3998 6.71988 12 7.34988 12H13.6498C14.2798 12 14.6997 12.3998 14.6997 12.9998C14.6997 13.5998 14.2798 13.9997 13.6498 13.9997Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9497 2.00013H1.04983C0.419833 2.00013 0 1.59983 0 0.999833C0 0.399839 0.419833 0 1.04983 0H19.9497C20.5797 0 20.9995 0.399839 20.9995 0.999833C20.9995 1.59983 20.5797 1.99967 19.9497 1.99967V2.00013Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.0670523f.svg";
export { ForwardRef as ReactComponent };